<ng-container *ngIf="layoutVars || layoutVarsResponse">
  <div class="row">
    <div class="col-md-8 mx-auto">
      <img [src]="layoutVars && layoutVars.logoUrl ? layoutVars.logoUrl : './assets/images/logo/logo-arremaq-superbid.png'"
        class="logo" [height]="layoutVars && layoutVars.logoUrl ? 48 : 53" />
    </div>
  </div>

  <div class="card o-hidden" [@animate]="{value:'*',params:{y:'120px',opacity:'0',delay:'100ms', duration: '400ms'}}">
    <div class="row">
      <div class="col-md-10 mx-auto" *ngIf="!createdSuccessfuly">
        <div class="row">
          <div class="col-md-12">
            <h4 class="text-center text-uppercase">Criar novo cadastro</h4>
          </div>
        </div>
        <div class="mt-2 mb-5">
          <form [formGroup]="form" (submit)="submit()">
            <div class="row" *ngIf="showError">
              <ngb-alert class="alert-card col-md-12" type="danger">
                <span *ngIf="errorCode === 'DUPLICATED_EMAIL'">Este e-mail já está cadastrado na nossa plataforma. Para
                  criar um novo cadastro, utilize outro endereço de e-mail.
                  Para acessar com este e-mail, <a [routerLink]="['/login']" class="hover-underline">clique
                    aqui</a>.</span>

                <span *ngIf="errorCode === 'DUPLICATED_CPF_CNPJ'">{{type === 'COMPANY' ? 'CNPJ' : 'CPF'}} já cadastrado.
                  Verifique novamente ou entre em
                  contato com o suporte.</span>
              </ngb-alert>
            </div>

            <div class="row-form">
              <mat-form-field>
                <mat-label>Tipo</mat-label>
                <mat-select (selectionChange)="resetCpfCpnj()" formControlName="type">
                  <mat-option *ngFor="let option of options" [value]="option.id">{{option.name}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div> 

            <div class="row-form">
              <mat-form-field>
                <mat-label>NOME{{type === 'COMPANY' ? ' FANTASIA' : ''}}</mat-label>
                <input matInput formControlName="name" class="input-text" />
              </mat-form-field>
            </div>


            <div class="row-form">
              <mat-form-field>
                <mat-label>E-MAIL</mat-label>
                <input matInput formControlName="email" class="input-text" (change)="checkEmail()" />
              </mat-form-field>
            </div>
            <div class="row-form" *ngIf="form">
              <mat-form-field *ngIf="type == 'PERSON'">
                <mat-label>CPF</mat-label>
                <input matInput formControlName="cpfCnpj" [textMask]="cpfmask" (change)="checkCpfCnpj()" />
                <mat-error *ngIf="
              form.controls.cpfCnpj.errors &&
              form.controls.cpfCnpj.errors.cpfcpnjInvalid
            ">{{ getErrorMessage() }}</mat-error>
              </mat-form-field>
              <mat-form-field *ngIf="type == 'COMPANY'">
                <mat-label>CNPJ</mat-label>
                <input matInput formControlName="cpfCnpj" [textMask]="cnpjmask" class="input-text"
                  (change)="checkCpfCnpj()" />
                <mat-error *ngIf="
              form.controls.cpfCnpj.errors &&
              form.controls.cpfCnpj.errors.cpfcpnjInvalid
            ">{{ getErrorMessage() }}</mat-error>
              </mat-form-field>
            </div>


            <div class="row-form" *ngIf="type === 'COMPANY'">
              <mat-form-field>
                <mat-label>RAZÃO SOCIAL</mat-label>
                <input matInput formControlName="legalName" class="input-text" />
              </mat-form-field>
            </div>
            <div class="row-form" *ngIf="form?.value?.type === 'COMPANY'">
              <mat-form-field>
                <mat-label>INSCRIÇÃO MUNICIPAL</mat-label>
                <input matInput formControlName="cityRegistration" />
              </mat-form-field>
            </div>
            <div class="row-form" *ngIf="form?.value?.type === 'COMPANY'">
              <mat-form-field>
                <mat-label>INSCRIÇÃO ESTADUAL</mat-label>
                <input matInput formControlName="stateRegistration" />
              </mat-form-field>
            </div>


            <div class="row-form" *ngIf="form?.value?.type === 'PERSON'">

              <mat-form-field class="select-filter" *ngIf="!noAllowSensitiveData">
                <mat-label>Data de nascimento</mat-label>
                <input matInput [textMask]="dateMask" formControlName="birthDate">

                <mat-error *ngIf="
                form.controls.birthDate.errors &&
                form.controls.birthDate.errors.birthDateInvalid
              ">Data de nascimento inválida</mat-error>
              </mat-form-field>


              <mat-form-field>
                <mat-label>Estado civil</mat-label>

                <mat-select aria-label="Select an option" formControlName="maritalStatus">
                  <div *ngFor="let item of maritalStatuses">
                    <mat-option [value]="item">{{ item }}</mat-option>
                  </div>
                </mat-select>

                <mat-error *ngIf="form.controls.maritalStatus.errors && form.controls.maritalStatus.errors.required">
                  Campo
                  obrigatório</mat-error>
              </mat-form-field>
            </div>
            <div class="row-form">
              <label>Segmentos de interesse</label>
              <div class="row small-gutter">
                <div class="col-3" *ngFor="let segment of allSegments">
                  <div class="card text-center segment-card"
                    [ngClass]="{'selected': isSegmentSelected(segment.segment)}"
                    (click)="toggleSegment(segment.segment)">
                    <div class="position-check">
                      <span class="material-icons check-selected mx-0">
                        check_circles
                      </span>
                    </div>
                    <i class="d-block mx-auto text-primary cursor-pointer" [ngClass]="segment.iconClass"></i>
                    {{segment.productLabel}}
                  </div>
                </div>
              </div>
            </div>
            <ng-container *ngIf="!noAllowSensitiveData">
            <div class="row-form">
              <mat-form-field>
                <mat-label>CEP</mat-label>
                <input matInput [textMask]="cepMask" formControlName="zipCode" (blur)="getCEP()" />
              </mat-form-field>
            </div>
            <div class="row-form">
              <mat-form-field>
                <mat-label>Endereço</mat-label>
                <input matInput formControlName="address" />
              </mat-form-field>
            </div>

            <div class="row-form">
              <mat-form-field>
                <mat-label>NÚMERO</mat-label>
                <input matInput formControlName="addressNumber" />
              </mat-form-field>
            </div>

            <div class="row-form">
              <mat-form-field>
                <mat-label>COMPLEMENTO</mat-label>
                <input matInput formControlName="addressComplement" />
              </mat-form-field>
            </div>

            <div class="row-form">
              <mat-form-field>
                <mat-label>Bairro</mat-label>
                <input matInput formControlName="district" />
              </mat-form-field>
            </div>

            <div class="row-form">
              <mat-form-field>
                <mat-label>CIDADE</mat-label>
                <input type="text" matInput formControlName="city" [matAutocomplete]="cityAutoComplete" />

                <mat-autocomplete #cityAutoComplete="matAutocomplete"
                  (optionSelected)="selectCity($event.option.value)">
                  <mat-option *ngFor="let option of cityOptions | async" [value]="option">
                    {{ option.name }} - {{ option.uf }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </ng-container>
            <div class="row-form">
              <mat-form-field>
                <mat-label>Telefone</mat-label>
                <input matInput [textMask]="telephoneMask" formControlName="phoneNumber" />
              </mat-form-field>
            </div>

            <div class="row-form" *ngIf="!layoutVars || !layoutVars.noNotificationWhatsapp">
              <mat-form-field appearance="none">
                <mat-label>Deseja receber mensagens via Whatsapp</mat-label>
                <mat-slide-toggle formControlName="whatsappOptin" (change)="changeWhatsappOptinStatus($event)"
                  style="margin-top: 24px;">
                  <span class="load-field-status">{{dealerDetails.whatsappOptin ? 'Sim' : 'Não'}}</span>
                </mat-slide-toggle>
                <textarea matInput hidden></textarea>

              </mat-form-field>
            </div>

            <div class="row-form" *ngIf="form.controls.whatsappOptin.value">
              <mat-form-field>
                <mat-label>Whatsapp</mat-label>
                <input matInput formControlName="whatsappNumber" class="input-text" [textMask]="telephoneMask" />
              </mat-form-field>
            </div>

            <div class="row-form" style="font-size: 12px">
              <mat-checkbox formControlName="noReceiveOffers" (change)="changeWhatsappOptinStatusCheck($event)" *ngIf="layoutVars && layoutVars.noNotificationWhatsapp">
                Não tenho interesse em receber comunicação com condições especiais e ofertas de produtos e serviços {{layoutVars.name}}
              </mat-checkbox>
              <div>
                <mat-checkbox
                  formControlName="acceptTermsOfUse"></mat-checkbox>
                <span class="ml-2">
                  Li e concordo com os
                  <a
                    [href]="termsOfUse"
                    target="_blank">
                    termos e condições de uso
                  </a>
                  da plataforma.
                </span>
              </div>
              <mat-error
                class="mb-2"
                *ngIf="form.controls.acceptTermsOfUse.errors && form.controls.acceptTermsOfUse.errors.required && form.controls.acceptTermsOfUse.dirty">
                É obrigatório aceitar os termos de uso
              </mat-error>

              <div class="accepted-terms mb-2" >
                Ao clicar em "Criar Cadastro", você está ciente de que a {{layoutVars && layoutVars.name ? layoutVars.name : 'Arremaq'}} irá coletar e tratar seus dados pessoais
                de acordo com a nossa <a [href]="layoutVars && layoutVars.footerLinkUrl ? layoutVars.footerLinkUrl : privacyPolicy" target="_blank" [style.color]="layoutVars && layoutVars.primaryColor ? layoutVars.primaryColor : 'var(--branded1)'">Política de Privacidade</a>.
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-12 text-center">
                <button class="btn btn-primary btn-lg btn-block">
                  CRIAR CADASTRO
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="col-md-10 mx-auto" *ngIf="createdSuccessfuly">
        <div class="row">
          <div class="col-md-12">
            <h4 class="text-center text-uppercase">Cadastro criado com sucesso!</h4>
          </div>
        </div>
        <div class="mt-2">
          <p>Seu cadastro está sendo avaliado pela nossa equipe. Assim que você estiver autorizado, você receberá um e-mail e poderá acessar
            nossas
            ofertas.</p>
          <!-- <p>Enquanto aguarda, você pode criar sua senha de acesso:</p> -->
        </div>

        <!-- <div class="row mt-4 mb-5">
          <div class="col-md-12 text-center">
            <button class="btn btn-primary" [routerLink]="['/login']">
              CRIAR SENHA
            </button>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</ng-container>